/**
 * FCL Import report catalog metadata (hub tiles, breadcrumbs).
 * Each report has its own page component and route in MainRoute.jsx.
 */
export const FCL_IMPORT_REPORT_REGISTRY = {
    booking: {
        title: "Booking Report",
        description: "Import bookings, profitability, and carrier mix.",
        group: "ops",
    },
    "active-shipment": {
        title: "Active Shipment Report",
        description: "Open import shipments in progress.",
        group: "ops",
    },
    demurrage: {
        title: "Container Demurrage Report",
        description: "Demurrage exposure and free-time usage.",
        group: "accounting",
    },
    trucking: {
        title: "Trucking Report",
        description: "Import delivery and trucking assignments.",
        group: "ops",
    },
    "status-audit": {
        title: "Status Audit Report",
        description: "Import status changes and audit history.",
        group: "ops",
    },
    "container-tracking": {
        title: "Container Tracking Report",
        description: "Container events, holds, and milestones.",
        group: "ops",
    },
    "arrival-notice": {
        title: "Arrival Notice Report",
        description: "Arrival notices issued to consignees.",
        group: "ops",
    },
    "eta-status": {
        title: "ETA Status Report",
        description: "Estimated times of arrival and status by vessel and port.",
        group: "ops",
    },
    "file-cancellation-report": {
        title: "File Cancellation Report",
        description: "Cancelled import files and cancellation details.",
        group: "ops",
    },
    "arrival-notice-pre-alert-report": {
        title: "Arrival Notice Pre-Alert Report",
        description: "Pre-alerts sent to clients before arrival notice.",
        group: "ops",
    },
};

export const getImportReportBySlug = (slug) => FCL_IMPORT_REPORT_REGISTRY[slug] ?? null;
